import React, { FC } from 'react';
import { Overlay, Text } from '@moda/om';
import { LoadingBalls } from '../../LoadingBalls';
import './GridLoading.scss';

interface Props {
  show: boolean;
}

export const GridLoading: FC<Props> = ({ show }) => (
  <Overlay className="GridLoading" show={show}>
    <LoadingBalls />
    <Text treatment="eyebrow">Fetching Results</Text>
  </Overlay>
);
